import { DepartmentEffects } from '@features/departments/store/departments.effects';
import { CurrentUserEffects } from './current-user/current-user.effects';
import { OrganizationEffects } from '@features/organizations/store/organizations.effects';
import { LocationEffects } from './location/location.effects';
import { MeterEffects } from '@features/meters/store/meters.effects';
import { FileImportEffects } from './file-import/file-import.effects';
import { MeterGroupEffects } from '@features/meter-group/store/meter-group.effects';
import { DashboardEffects } from '@features/dashboard/store/dashboard.effects';

export const rootEffects = [
  CurrentUserEffects,
  DepartmentEffects,
  OrganizationEffects,
  LocationEffects,
  MeterEffects,
  FileImportEffects,
  MeterGroupEffects,
  DashboardEffects,
];
